<template>
  <v-layout
    row
    wrap
    class="text-xs-center align-content-center"
    fill-height
  >
    <v-flex xs12>
      <v-progress-circular
        indeterminate
        size="60"
        color="primary"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { verificarPaciente } from '../api/userEndpoints'

export default {
  name: 'AutoLoginView',
  data () {
    return {
      menu: false
    }
  },
  async mounted () {
    const verifiedPatient = await verificarPaciente((this.$route.query.pid) ? this.$route.query.pid : this.$route.query.p)
    if (verifiedPatient.respuesta === 'ERROR') {
      this.$createAlert({
        message: verifiedPatient.mensaje,
        type: 'error',
        duration: 5000
      })
      this.$router.replace({ name: 'SelectionView' })
    } else {
      await this.$store.dispatch('setUser', { patient: verifiedPatient.paciente })
      if ((this.$route.query.modo) ? this.$route.query.modo === 'informes' : this.$route.query.o === 'informes') {
        this.$router.replace({ name: 'ReportsView' })
      } else {
        this.$router.replace({ name: 'AppointmentsView' })
      }
    }
  }
}
</script>

<style scoped lang="sass">
  .progress-circle
    margin: 40vh auto
</style>
